import { render, staticRenderFns } from "./images.vue?vue&type=template&id=2056c315"
import script from "./images.js?vue&type=script&lang=js&external"
export * from "./images.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports